export default "__VITE_ASSET__Cxx7G4Uq__"